import { CompoundPredicate, Predicate } from '@standardnotes/models';
import { Migration } from '@Lib/Migrations/Migration';
import { ApplicationStage } from '@standardnotes/services';
import { ContentType } from '@standardnotes/domain-core';
export class Migration2_7_0 extends Migration {
    static version() {
        return '2.7.0';
    }
    registerStageHandlers() {
        this.registerStageHandler(ApplicationStage.FullSyncCompleted_13, async () => {
            await this.deleteBatchManagerSingleton();
            this.markDone();
        });
    }
    async deleteBatchManagerSingleton() {
        const batchMgrId = 'org.standardnotes.batch-manager';
        const batchMgrPred = new CompoundPredicate('and', [
            new Predicate('content_type', '=', ContentType.TYPES.Component),
            new Predicate('identifier', '=', batchMgrId),
        ]);
        const batchMgrSingleton = this.services.singletonManager.findSingleton(ContentType.TYPES.Component, batchMgrPred);
        if (batchMgrSingleton) {
            await this.services.mutator.setItemToBeDeleted(batchMgrSingleton);
        }
    }
}
